import { GraphDisplayData } from "../../data";

export const REPLACE_GRAPH_DISPLAY_DATA : string = 'graphdisplaydata:replace-graph-display-data';

export interface GraphDisplayDataAction {
  type: typeof REPLACE_GRAPH_DISPLAY_DATA;
  payload: GraphDisplayData[];
}